module.exports = __webpack_public_path__ + "static/media/interface.6f2498c3.png";